/* accessory-guard: the MAT Pillow Pro and the Silk Eye Mask go only with MAT Plus or MAT Pro.
   State comes from sections/accessory-guard.liquid (server side, re-fetched after every cart change). */
(function () {
  var root = document.querySelector('[data-acg]'); if (!root) return;
  var stateEl = document.querySelector('[data-acg-state]'), rowTpl = document.querySelector('[data-acg-row]'), offerTpl = document.querySelector('[data-acg-offer]');
  var list = root.querySelector('[data-acg-list]'), offersEl = root.querySelector('[data-acg-offers]');
  var KEY = 'wj_acg_ack', onCart = /^\/cart\/?$/.test(location.pathname);
  var q = location.search.match(/[?&]acgpreview=([01])(?:&|$)/);
  try { if (q) { if (q[1] === '1') localStorage.setItem('wj_acg_preview', '1'); else localStorage.removeItem('wj_acg_preview'); } } catch (e) {}
  var preview = false; try { preview = localStorage.getItem('wj_acg_preview') === '1'; } catch (e) {}
  var state = parse(stateEl && stateEl.textContent);
  function parse(t) { try { return JSON.parse(t); } catch (e) { return null; } }
  function on(s) { return !!(s && s.enabled && (s.live || preview)); }
  function blocked(s) { return on(s) && s.rows.length > 0 && !s.trigger; }
  function sig(s) { return s.rows.map(function (r) { return r.key + ':' + r.qty; }).sort().join('|'); }
  function acked(s) { try { return sessionStorage.getItem(KEY) === sig(s); } catch (e) { return false; } }
  function ack(s) { try { sessionStorage.setItem(KEY, sig(s)); } catch (e) {} }
  function post(url, body) { return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }); }
  function render(s) {
    list.innerHTML = ''; offersEl.innerHTML = '';
    s.rows.forEach(function (r) {
      var n = rowTpl.content.cloneNode(true), im = n.querySelector('img');
      if (r.img) im.src = r.img; else im.remove();
      n.querySelector('.po__name').textContent = r.title + (r.qty > 1 ? ' × ' + r.qty : '');
      list.appendChild(n);
    });
    var label = root.getAttribute('data-add-label') || 'Add [title] · [price]';
    s.offers.forEach(function (o) {
      var b = offerTpl.content.firstElementChild.cloneNode(true);
      b.setAttribute('data-variant', o.variant);
      b.textContent = label.replace('[title]', o.title).replace('[price]', o.price);
      if (!o.available) b.disabled = true;
      offersEl.appendChild(b);
    });
  }
  function open(s) {
    render(s); root.hidden = false; document.documentElement.classList.add('po-open', 'acg-open');
    var po = document.querySelector('[data-po]'); if (po) po.hidden = true;
  }
  function close() { root.hidden = true; document.documentElement.classList.remove('acg-open'); if (!document.querySelector('[data-po]:not([hidden])')) document.documentElement.classList.remove('po-open'); }
  function mark(s) { document.documentElement.classList.toggle('acg-block', blocked(s)); }
  function refresh() {
    return fetch('/?sections=accessory-guard', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      var m = (j['accessory-guard'] || '').match(/data-acg-state>([\s\S]*?)<\/script>/);
      if (!m) return null; state = parse(m[1]); mark(state); return state;
    }).catch(function () { return null; });
  }
  function maybe(s) { mark(s); if (blocked(s) && !acked(s)) open(s); else if (!blocked(s)) close(); }
  function done() {
    if (onCart) { location.reload(); return; }
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'accessory-guard' } }));
  }

  maybe(state);
  document.addEventListener('cart:update', function (e) {
    if (e.detail && e.detail.source === 'accessory-guard') return;
    setTimeout(function () { refresh().then(function (s) { if (s) maybe(s); }); }, 350);
  });
  /* no checkout while a companion sits in the cart without its MAT: the sheet comes back at the checkout button */
  function isCheckout(el) {
    return !!el.closest('[name="checkout"], a[href^="/checkout"], a[href*="/checkouts/"], button[form][name="checkout"]');
  }
  document.addEventListener('click', function (e) {
    if (!blocked(state) || !e.target.closest || !isCheckout(e.target)) return;
    e.preventDefault(); e.stopImmediatePropagation(); open(state);
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target, sub = e.submitter;
    if (!blocked(state) || !f || !f.action) return;
    if (/\/checkout/.test(f.action) || (sub && sub.name === 'checkout')) { e.preventDefault(); e.stopImmediatePropagation(); open(state); }
  }, true);

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-acg-close]')) { ack(state); close(); return; }
    var no = e.target.closest('[data-acg-no]');
    if (no) {
      no.disabled = true;
      var upd = {}; state.rows.forEach(function (r) { upd[r.key] = 0; });
      post('/cart/update.js', { updates: upd }).then(function () { return refresh(); }).then(function () { close(); done(); })
        .catch(function () { no.disabled = false; });
      return;
    }
    var add = e.target.closest('[data-acg-add]'); if (!add) return;
    [].slice.call(offersEl.children).forEach(function (b) { b.disabled = true; });
    add.textContent = '…';
    /* the companions already in the cart become the MAT's gifts: the gift guard (woojer-mat-bundle) adds one of each per
       Plus/Pro, so one unit of each is taken off here first; side b of the gift test gets no gifts, so nothing is taken off */
    var giftSide = document.documentElement.getAttribute('data-wjgt') !== 'b', upd = {}, seen = {};
    if (giftSide) state.rows.forEach(function (r) {
      if (r.gift || seen[r.handle]) return; seen[r.handle] = 1; upd[r.key] = Math.max(r.qty - 1, 0);
    });
    /* the MAT goes in first: if that fails, nothing in the cart has changed */
    post('/cart/add.js', { items: [{ id: parseInt(add.getAttribute('data-variant'), 10), quantity: 1 }] })
      .then(function (r) { if (!r.ok) throw r; return Object.keys(upd).length ? post('/cart/update.js', { updates: upd }) : null; })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () { refresh().then(function (s) { if (s) render(s); }); });
  });
})();
